import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlaySmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 13,
	viewBox: "0 0 10 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.07053 12.8748L9.77865 6.90164C10.0475 6.71723 10.0753 6.39635 9.84083 6.18494C9.82198 6.16794 9.80171 6.15195 9.78016 6.13708L1.07204 0.126209C0.803934 -0.0588558 0.395815 -0.0379609 0.160482 0.172879C0.057041 0.265555 0 0.384656 0 0.507969V12.492C0 12.7726 0.289195 13 0.645936 13C0.802049 13 0.95288 12.9555 1.07053 12.8748Z",
		fill: "#4D4D54"
	})
});
export default SvgPlaySmall;
